import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {

  private readonly ngTitle = inject(Title);
  private readonly translateService = inject(TranslateService);

  // Binding to navigation events to update page title
  // from routing data can also be implemented here.

  private pageName?: string;

  public set title(name: string | undefined) {
    this.pageName = name;
    this.ngTitle.setTitle(
      this.prepareTitle(this.pageName)
    );
  }

  public get title(): string | undefined {
    return this.pageName;
  }

  public reset(): void {
    this.title = undefined;
  }

  private prepareTitle(pageName?: string): string {
    const baseNames = [
      pageName,
      this.translateService.instant('common.page_title.suffix')
    ];

    return baseNames
      .filter(item => !!item)
      .join(' | ');
  }

}
